import Login from "./Login";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./Dashboard";
import { useEffect } from "react";

import { useSessionStorage } from "../IF/userSession";
import NoMatch from "./NoMatch";
import AppLayout from "./layout/AppLayout";
import Alert from "./Alert";
import Report from "./Report";
import SettingWorker from "./SettingWorker";
import SettingArea from "./SettingArea";
import SettingMail from "./SettingMail";
import SettingUser from "./SettingUser";
import { useAppDispatch, useAppSelector } from "Hooks/hooks";
import { fetchData } from "Action/slice";
import { ViewProvider } from "Contexts/ViewProvider";
import { DataProvider } from "Contexts/DataProvider";
import { ThemeProvider } from "Contexts/ThemeContext";
import CompanyIdIssuance from "./CompanyIdIssuance";
import SimSerialNoMapping from "./SimSerialNoMapping";
import SettingVarious from "./SettingVarious";
import AdvancedConfiguration from "./AdvancedConfiguration";
import ManageBackupsPage from "./ManageBackupsPage";
import MessageLogsPage from "./MessageLogsPage";
import SettingAreaHistory from "./SettingAreaHistory";

function App() {
  // セッションのuserDataを取得関数
  const { getUserData } = useSessionStorage();
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.data);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const userData = getUserData();
      if (userData.companyCode && userData.companyCode !== "9226")
        dispatch(fetchData(userData));
    }, 5000); // 5秒ごとにAPIを実行

    return () => clearInterval(intervalId);
  }, [dispatch, getUserData]);

  return (
    <ThemeProvider>
      <ViewProvider>
        <DataProvider>
          <Router basename="/">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/" element={<AppLayout />}>
                <Route path="/IdIssuance" element={<CompanyIdIssuance />} />
                <Route
                  path="/SimSerialNoMapping"
                  element={<SimSerialNoMapping />}
                />
                <Route
                  path="/ManageBackupsPage"
                  element={<ManageBackupsPage />}
                />
                <Route
                  path="/AdvancedConfiguration"
                  element={<AdvancedConfiguration />}
                />
                <Route path="/Dashboard" element={<Dashboard data={data} />} />
                <Route path="/Alert" element={<Alert data={data} />} />
                <Route path="/Report" element={<Report />} />
                <Route path="/Setting/worker" element={<SettingWorker />} />
                <Route path="/Setting/area" element={<SettingArea />} />
                
                <Route path="/Setting/AreaHistory" element={<SettingAreaHistory />} />
                
                <Route path="/Setting/mail" element={<SettingMail />} />
                <Route
                  path="/Setting/MessageLogs"
                  element={<MessageLogsPage />}
                />
                <Route path="/Setting/user" element={<SettingUser />} />
                <Route path="/Setting/Various" element={<SettingVarious />} />
              </Route>
              <Route path="*" element={<NoMatch />} />
            </Routes>
          </Router>
        </DataProvider>
      </ViewProvider>
    </ThemeProvider>
  );
}

export default App;
